import React from 'react';
import { useStore } from '../../../../../stores/root';

// assets

// services

// props

// components
import { Stack } from '@fluentui/react';
import Label from '../../../../typography/label';
import Text from '../../../../typography/text';
import GeneralService from '../../../../../services/general';
import Details from '../../../../typography/details';
import { IOrderAddonResourceProps } from '../../../../../props/orders/orderAddon';

type OrderAddonDetailsPropertiesProps = {
    addon: IOrderAddonResourceProps;
}

const OrderAddonDetailsProperties: React.FC<OrderAddonDetailsPropertiesProps> = (props: OrderAddonDetailsPropertiesProps) => {
    const { addon } = props;
    const { banner } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [submitting, setSubmitting] = React.useState<boolean>(false);
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();

    return <Stack tokens={{ childrenGap: 15 }} styles={{ root: { marginTop: 10 } }}>
        <Details title={'Name'} text={addon.name || "-"} />
        <Details title={'Notes'} text={addon.notes || "-"} />
        <Details title={'Quantity'} text={GeneralService.getNumberWithSeparator(Number(addon.quantityAmount)) + " " + (addon.quantityUnit?.name || "")} />
        <Stack className={'divider'}></Stack>
        <Label size={'small'}>Pricing Details</Label>
        <Stack>
            <Stack horizontal tokens={{childrenGap: 20}}>
                {addon.priceType === 'lumpsum' ? <Details title={'Price (lumpsum)'} text={`Rp. ${GeneralService.getNumberWithSeparator(addon.price || "0")}`} style={{width: '100%'}} /> : null}
                {addon.priceType === 'perquantity' ? <>
                    <Details title={'Price (per quantity)'} text={`Rp. ${GeneralService.getNumberWithSeparator(addon.price || "0")}`} style={{width: '50%'}} />
                    <Details title={'Total Price'} text={`Rp. ${GeneralService.getNumberWithSeparator(addon.totalPrice || "0")}`} style={{width: '50%'}} />
                </> : null}
            </Stack>
            <Stack horizontal tokens={{childrenGap: 5}}>
                {addon.includePPn ? <Text size={'small'} className={'color-green'}>(include PPn)</Text> : null}
                {addon.includePPh ? <Text size={'small'} className={'color-green'}>(include PPh)</Text> : null}
                {!addon.includePPn ? <Text size={'small'} className={'color-red'}>(exclude PPn)</Text> : null}
                {!addon.includePPh ? <Text size={'small'} className={'color-red'}>(exclude PPh)</Text> : null}
            </Stack>
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={`PPn (${addon.ppnPercentage}%)`} text={`Rp. ${GeneralService.getNumberWithSeparator(Number(addon.ppn))}`} style={{width: '50%'}} />
            <Details title={`PPh (${addon.pphPercentage}%)`} text={`Rp. ${GeneralService.getNumberWithSeparator(Number(addon.pph))}`} style={{width: '50%'}} />
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={`Price (inc. PPn & PPh)`} text={`Rp. ${GeneralService.getNumberWithSeparator(addon.finalPrice)}`} style={{width: '50%'}} />
            <Details title={`Invoice price (total price - PPh)`} text={`Rp. ${GeneralService.getNumberWithSeparator(addon.invoicePrice)}`} style={{width: '50%'}} />
        </Stack>
    </Stack>
};

export default OrderAddonDetailsProperties;
